<template>
    <div class="finExamen">
        <div class="container">
            <div class="row ">
                <div class="col-8 col-lg-8">
                    <h3>{{ user.state.name }} {{user.state.primerApellido}} su examen ha sido enviado correctamente</h3>
                    <p>Leer la siguiente información con atención.<br />
                        El examen fue presentado para las siguientes categorías:</p>
                    <ul>
                        <li> Licencia categoría {{ user.state.categoriaLicencia }}</li>
                        <!-- <li> Licencia categoría 00</li> -->
                    </ul>
                    <p>El centro CALE le informará de su resultado en el momento que su calificación esté disponible.
                         Por favor termine su sesión con el botón "Salir" que se encuentra en la parte superior derecha.
                    </p>
                </div>
            </div>
        </div>

    </div>
    <!-- <router-link to="/Aspirante">Aspirante</router-link><br/>
    <router-link to="/Pruebas">Pruebas</router-link> -->



</template>

<script >
import { useStore } from 'vuex'

export default {
    name: 'FinExamen',

    setup() {
        const user = useStore();
        return { user }
    },
    mounted(){
            //Deshabilitar retroceso en la ventana del navegador
    window.location.hash = "no-back-button";
    window.location.hash = "Again-No-back-button" //chrome
    window.onhashchange = function () { window.location.hash = ""; }

    },
    methods:{
    }
}

</script>

<style lang="scss" >

.finExamen{
    padding-top: 4%;
    padding-bottom: 10%;

    h3{
        font-size: 26px;
        color: #071D49;
    }
    p{
        font-size: 16px;
        color: #4B4B4B;
    }
}

</style>